import React, { Component } from 'react';    
import { Form, FormField, Input, Select, Row, Col, Button, Text, Translate } from '$common';
import Layout from './layout';
import companySizes from '$constants/company_sizes.json';



export default class SignUp extends Component {

  handleSubmit(values) {
    this.props.onCreate(values);
    setTimeout(function(){
      if (!this.props.errors) {
        this.props.onLogin({ email: values.email, password: values.password });
      }
    }.bind(this), 400);
  }
  
  render() {
    const { sectors, errors, roles, defaults } = this.props;

    return (    
      <Layout
        title={Translate.get('signup_page_title')}
        type={'signup'}
        valueProposition={
          <ul>
            <li>{Translate.get('signup_value_proposition_1')}</li>
            <li>{Translate.get('signup_value_proposition_2')}</li>
            <li>{Translate.get('signup_value_proposition_3')}</li>
          </ul>
        }
      >
        <Form onSubmit={::this.handleSubmit} errors={errors} defaults={defaults}>
          <Row>
            <Col md="1/2">
              <FormField name="first_name" label={Translate.get('first_name')}>
                <Input type="text" forceOnChange />
              </FormField>
            </Col>
            <Col md="1/2">
              <FormField name="last_name" label={Translate.get('last_name')}>
                <Input type="text" forceOnChange />
              </FormField>
            </Col>
            <Col md="1/2">
              <FormField name="email" label={Translate.get('email')}>
                <Input type="email" />
              </FormField>
            </Col>
            <Col md="1/2">
              <FormField name="password" label={Translate.get('password')}>
                <Input type="password" forceOnChange />
              </FormField>
            </Col>
          </Row>
          <Row>
            <Col md="1/2">
              <FormField name="sectorId" label={Translate.get('industry')}>
                <Select
                  options={sectors.map(({ id, name }) => ({ label: name, value: id }))}   
                />
              </FormField>
            </Col>
            <Col md="1/2">
              {
                roles ?
                  <FormField name="customer_role_id" label={Translate.get('job_title')}>
                    <Select
                      options={roles.map(({ id, name }) => ({ label: name, value: id }))}
                    />
                  </FormField>
                : ''
              }
            </Col>
          </Row>
          <Row>
            <Col md="1/2">
              <FormField name="account" label={Translate.get('company')}>
                <Input type="text" forceOnChange />
              </FormField>
            </Col>
            <Col md="1/2">
              <FormField name="companySize" label={Translate.get('company_size')}>
                <Select
                  options={companySizes}   
                />
              </FormField>
            </Col>
          </Row>  
          <Text size="small" align="center">{Translate.get('terms_and_conditions')}</Text>
          <p><Button type="success" submit block id="live-sign-up-button" size="micro">{Translate.get('create_account')}</Button></p>   
        </Form>
      </Layout>
    )   
  }   
}



// WEBPACK FOOTER //
// ./src/components/auth/signup.js